import api from './api';

export async function loginDirect({ email, password }) {
  try {
    const response = await api.post('/CommonChannel/ValidateUserDirect', {
      Email: email,
      Password: password
    }, {
      validateStatus: (status) => (status >= 200 && status < 300) || status === 401 || status === 204
    });

    if (response.status === 204 || response.status === 401) {
      return { success: false, error: 'Invalid User ID or Password' };
    }

    const data = response.data;
    const userId = data?.user_Id || data?.userId;
    if (!userId) {
      return { success: false, error: 'User ID not found' };
    }

    return {
      success: true,
      user: {
        ...data,
        userId,
        email
      }
    };
  } catch (error) {
    return { success: false, error: error?.message || 'Authentication failed' };
  }
}

export async function guestLogin({ firstName, lastName, email, phone }) {
  try {
    const response = await api.post('/Auth/guest-login', {
      firstName: firstName.trim(),
      lastName: lastName.trim(),
      email: email.trim(),
      phone: phone.trim()
    });

    const responseData = response.data;

    if (!responseData?.success) {
      return { success: false, error: responseData?.message || 'Guest login failed' };
    }

    const userId = responseData?.data?.userId;
    const token = responseData?.data?.token;

    if (!userId) {
      return { success: false, error: 'Invalid response from server' };
    }

    return {
      success: true,
      token,
      user: {
        user_Id: userId,
        userId,
        user_Email: responseData?.data?.email,
        email: responseData?.data?.email,
        user_First_Name: firstName,
        user_Last_Name: lastName,
        firstName,
        lastName,
        fullName: responseData?.data?.fullName,
        roles: responseData?.data?.roles,
        isGuest: true,
        is_Guest: 'Y'
      }
    };
  } catch (error) {
    return { success: false, error: error?.message || 'Guest login failed' };
  }
}
